import { useState } from "react";
import axios from "axios";
import { API_URL } from "../../Constants";

export default function NoteForm({ setOpenForm, onSave, onClose, user, companyId }) {
  const [note, setNote] = useState("");
  const [type, setType] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      await axios.post(
        `${API_URL}/api/notes`,
        {
          note,
          type,
          companyId,
          createdById: user?.id,
          createdByName: user?.name,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNote("");
      setType("");
      onSave?.(); // Call the onSave callback if provided
      setOpenForm?.(null); // Close the form
      onClose?.(); // Additional close handler if provided
    } catch (err) {
      console.error("Failed to save note:", err);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-4">
      <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
        Note
      </label>
      <textarea
        className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
        placeholder="Enter your note"
        rows="3"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        required
      />
      <label className="block text-sm font-medium text-gray-700 mt-4 mb-1 dark:text-white">
        Type
      </label>
      <input
        className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
        placeholder="Enter type"
        value={type}
        onChange={(e) => setType(e.target.value)}
        required
      />
      <button
        type="submit"
        className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
      >
        Save Note
      </button>
    </form>
  );
}